module.exports = __webpack_public_path__ + "img/product10p.2942ec02.png";